import axios from 'axios'
import ApplicationController from '../application_controller.js'
import { isBlank } from '../../commons.js'

export default class CfileController extends ApplicationController {

  static targets = [
    "clients", "contacts", "entities", "domain"
  ]

  //
  // Masque les contrôles d'un groupe
  // eg. Création client, moral ou physique
  //  data-group : groupe d'éléments, eg. client-type
  //  data-group-value : valeur de regroupement des éléments (correspondant à une valeur de select) eg. corporate ou individual
  //
  select_billing(e) {
    const group = e.target.dataset.group
    const form = e.target.closest('form')

    form.querySelectorAll(`.hiddable[data-group='${group}']`).forEach(el => el.style.display = 'none')
    form.querySelectorAll(`.hiddable[data-group='${group}'][data-group-value='${e.target.value}']`).forEach(el => el.style.display = 'block')
  }

  //
  // Gère une checkbox seule à être active au sein d'un même groupe
  // eg. Cfile, un seul apporteur d'affaire
  // Si uncheckAllowed est absent des proprietés il faut une checkbox cochée obligatoirement
  //  data-group : groupe de checkboxes
  //
  checkbox_group(e) {
    const check_state = e.target.checked
    const form = e.target.closest('form')

    form.querySelectorAll(`input[type=checkbox][data-group='${e.target.dataset.group}']`).forEach(e => e.checked = false)

    if (e.target.dataset.uncheckAllowed === undefined)
      e.target.checked = true
    else
      e.target.checked = check_state

    // Lors du clic sur une checkbox "responsable", affecte le domain_id de l'utilisateur selectionné au champ déroulant "domain"
    // Mais uniquement si le clic porte sur une checkbox du groupe "users" et que le cfile est en création
    if (this.element.dataset.recordPersisted == "false" && e.target.dataset.group == "users") {
      const user_select = e.target.closest('tr').querySelector('.user_select')
      const domain_id = user_select.options[user_select.selectedIndex].dataset.domainId
      this.domainTarget.value = domain_id
    }

    // Applique le pourcentage de l'AppProperty cfiles_distribution au champ percent de la même ligne
    const hourlyRateInput = e.target.closest('tr').querySelector('.percent')
    if (check_state) {
      hourlyRateInput.dataset.previousPercent = hourlyRateInput.value
      hourlyRateInput.value = e.target.dataset.distributionPercent
      // } else if (hourlyRateInput.dataset.previousPercent !== undefined) {
      //   hourlyRateInput.value = hourlyRateInput.dataset.previousPercent
      // }
    }
  }

  //
  // Ajout d'un enregistrement nested_form dans une table
  //  data-target : élément du dom
  //  data-fields : formulaire
  //
  add_nested_record(e) {
    e.preventDefault()
    let new_fields = e.target.dataset.fields
    new_fields = new_fields.replace(new RegExp('NESTED_DYNAMIC_FORM', 'g'), performance.now().toString().replace('.', ''))
    e.target.closest('form').querySelector(e.target.dataset.target).insertAdjacentHTML('beforeend', new_fields)
  }

  remove_nested_record(e) {
    e.preventDefault()
    const parent = e.target.closest('tr')
    parent.querySelector("[name*='_destroy']").value = "1"
    parent.style.display = 'none'
  }

  select_client(e) {
    if (!isBlank(e.target.value))
      this.visit(e.target.options[e.target.selectedIndex].dataset.path)
  }

  select_entity(e) {
    const form = e.target.closest('form')
    const selected = e.target.options[e.target.selectedIndex]
    form.querySelector('.entity_complement1').innerText = ""
    form.querySelector('.entity_complement2').innerText = ""
    form.querySelector('.entity_street').innerText = ""
    form.querySelector('.entity_zipcode_city').innerText = ""
    form.querySelector('.entity_vat_type').innerText = ""
    form.querySelector('.entity_complement1').innerText = selected.getAttribute("data-complement1")
    form.querySelector('.entity_complement2').innerText = selected.getAttribute("data-complement2")
    form.querySelector('.entity_street').innerText = selected.getAttribute("data-street")
    form.querySelector('.entity_zipcode_city').innerText = selected.getAttribute("data-city-zipcode")
    form.querySelector('.entity_vat_type').innerText = selected.getAttribute("data-vat")
  }

  select_invoice_contact(e) {
    const form = e.target.closest('form')
    const selected = e.target.options[e.target.selectedIndex]

    const el_contact_email = form.querySelector('.contact_email')
    const el_contact_main_phone = form.querySelector('.contact_main_phone')
    const el_contact_mobile_phone = form.querySelector('.contact_mobile_phone')

    el_contact_email.innerText = selected.getAttribute('data-email')
    el_contact_main_phone.innerText = selected.getAttribute('data-main-phone')
    el_contact_mobile_phone.innerText = selected.getAttribute('data-mobile-phone')
  }

  select_user_cfile(e) {
    const hourly_rate = e.target.options[e.target.selectedIndex].dataset.hourlyRate
    e.target.closest('tr').querySelector('.hourly_rate').value = hourly_rate
  }

  schedule_generator(e) {
    e.preventDefault()
    const cfile_form = e.target.closest('form')

    axios.get(e.target.href).then(response => {
      this.modal(response.data, { confirm_text: e.target.dataset.confirmText }, reason => {
        if (reason.confirm) {
          if (isBlank(reason.form.querySelector('[name=amount]').value)) {
            this.alert("Le montant de l'échéance ne peut pas être nul")
          } else {
            reason.close_modal()
            axios.post(reason.form.action, new FormData(reason.form)).then(response => {
              const link = cfile_form.querySelector('a[data-target="#cfile_schedules tbody"]')
              for (const schedule of response.data) {
                link.dispatchEvent(new Event('click')) // Simule un click sur le lien "Ajouter une échéance"
                const tr = cfile_form.querySelector('#cfile_schedules tbody tr:last-child')
                tr.querySelector('.cfile_scheduled_entry_date').value = schedule.scheduled_date
                tr.querySelector('.cfile_scheduled_entry_amount').value = schedule.amount
              }
            })
          }
        } else {
          reason.close_modal()
        }
      })
    })
  }

}